import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Rol } from '../models/rol';
import { RolViewModel } from '../models/rol-view-model';

@Injectable({
  providedIn: 'root'
})
export class RolService {

 constructor(private db: AngularFirestore) { }

 private rolCollectionName = 'roles';

 getRoles(): Observable<firebase.default.firestore.QuerySnapshot> {
  return this.db.collection<Rol>(this.rolCollectionName, ref => ref.where("_lgBaja", "==", false).orderBy('orden', 'asc')).get();
 }

 saveRol(rol: Rol): Promise<DocumentReference<any>> {
  return this.db.collection(this.rolCollectionName).add(rol);
 }

 editRol(rol: RolViewModel): Promise<void>{
  return this.db.collection(this.rolCollectionName).doc(rol.id).update(rol);
 }

 editRolPartial(id: string, obj: Object): Promise<void>{
  return this.db.collection(this.rolCollectionName).doc(id).update(obj);
 }

 deleteRol(idRol: string): Promise<void>{
  return this.db.collection(this.rolCollectionName).doc(idRol).delete();
 }
}
